var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{ref:"myIframe",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://eminwechat.xjzdcsyyyxzrgs.com/proxy-lab/?viewName=emin_view","scrolling":"auto","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }